import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import styled from 'styled-components';
import { MediaBreakPointUp } from "../../theme";
export var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-osf5s-0"
})(["background:#f5f7fb;min-height:100vh;", ""], _ref => {
  var theme = _ref.theme;
  return theme.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: linear-gradient(179.78deg, #3F366D 19.39%, #6F5294 115.94%);\n  "])));
});
export var StyledMainWrapper = styled.div.withConfig({
  displayName: "StyledMainWrapper",
  componentId: "sc-osf5s-1"
})(["width:100%;max-width:1200px;margin:0 auto;overflow:auto;"]);
export var StyledMainContentWrapper = styled.div.withConfig({
  displayName: "StyledMainContentWrapper",
  componentId: "sc-osf5s-2"
})(["display:flex;flex-flow:row nowrap;justify-content:center;align-items:flex-start;gap:24px;width:100%;margin:0 auto;", ""], _ref2 => {
  var theme = _ref2.theme;
  return theme.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-flow: column nowrap;\n    gap: 0;\n  "])));
});
export var StyledFormsWrapper = styled.div.withConfig({
  displayName: "StyledFormsWrapper",
  componentId: "sc-osf5s-3"
})(["", ""], _ref3 => {
  var theme = _ref3.theme;
  return theme.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n  "])));
});
export var Row = styled.div.withConfig({
  displayName: "Row",
  componentId: "sc-osf5s-4"
})(["display:flex;flex-flow:column nowrap;gap:8px;"]);
export var StyledRowLabel = styled.div.withConfig({
  displayName: "StyledRowLabel",
  componentId: "sc-osf5s-5"
})(["font-size:12px;font-weight:400;line-height:16px;color:#2c2842;"]);
export var StyledInputWrapper = styled.div.withConfig({
  displayName: "StyledInputWrapper",
  componentId: "sc-osf5s-6"
})(["display:flex;align-items:center;background:#fafafc;border:1px solid #e8e9f2;border-color:", ";border-radius:56px;width:100%;height:56px;padding:10px 24px;"], _ref4 => {
  var borderColor = _ref4.borderColor;
  return borderColor !== null && borderColor !== void 0 ? borderColor : '#e8e9f2';
});
export var Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-osf5s-7"
})(["background:transparent;border:none;color:#2c2842;font-size:16px;font-weight:500;line-height:140%;outline:none;width:", ";padding:0;::-webkit-input-placeholder{color:#b2b5cc;font-weight:500;font-size:16px;}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}@media screen and (max-width:", "){font-size:12px;::-webkit-input-placeholder{font-size:12px;}}-moz-appearance:textfield;"], _ref5 => {
  var width = _ref5.width;
  return width !== null && width !== void 0 ? width : '40px';
}, MediaBreakPointUp.sm);
export var InputHelpText = styled.div.withConfig({
  displayName: "InputHelpText",
  componentId: "sc-osf5s-8"
})(["color:#5a5d6d;font-size:16px;font-weight:400;line-height:140%;width:100%;margin-left:8px;@media screen and (max-width:", "){font-size:12px;}"], MediaBreakPointUp.sm);
export var StyledReferWrapper = styled.div.withConfig({
  displayName: "StyledReferWrapper",
  componentId: "sc-osf5s-9"
})(["display:flex;flex-flow:row nowrap;align-items:center;gap:12px;"]);
export var StyledReferLabel = styled.span.withConfig({
  displayName: "StyledReferLabel",
  componentId: "sc-osf5s-10"
})(["font-size:12px;font-weight:500;line-height:16px;color:#9c9fb4;"]);
export var StyledReferItemsWrapper = styled.div.withConfig({
  displayName: "StyledReferItemsWrapper",
  componentId: "sc-osf5s-11"
})(["display:flex;flex-flow:row nowrap;align-items:center;"]);
export var StyledReferItem = styled.div.withConfig({
  displayName: "StyledReferItem",
  componentId: "sc-osf5s-12"
})(["display:flex;flex-flow:row nowrap;align-items:center;color:#5f4dbc;font-size:12px;font-weight:500;line-height:16px;cursor:pointer;"]);
export var Divider = styled.span.withConfig({
  displayName: "Divider",
  componentId: "sc-osf5s-13"
})(["display:inline-block;margin:0 10px;height:16px;width:1px;background-color:rgba(0,0,0,0.1);"]);
export var StyledErrorMsg = styled.p.withConfig({
  displayName: "StyledErrorMsg",
  componentId: "sc-osf5s-14"
})(["color:#e75b55;font-size:12px;font-weight:500;line-height:16px;margin:0;"]);